import { MultiplatformSDKInstance } from '../sdk';

export abstract class SDKFacade {
  constructor(protected sdk: MultiplatformSDKInstance) {}
  static get singleton(): SDKFacade {
    throw new Error('Method not implemented! Use derived class');
  }
}
